import React from "react";
import { withReviewsInline } from "./withReviewsInline";
import clsx from "clsx";

const ReviewsInline = withReviewsInline(({ productGroup, className }) => {
  return (
    <a className="flex" href="#reviews">
      <span
        className={clsx(className, "ruk_rating_snippet")}
        data-sku={productGroup}
      />
    </a>
  );
});

export default ReviewsInline;
